import * as React from "react";

import "./ml-column.scss";

import {cs}                     from "@Common/react/chain-services";

import {MlCard}                 from "./ml-card/ml-card";
import {UseState}               from "@Common/react/use-state";
import {Pagination}             from "@Common/ui-components/heavy/common/design2/data-table/pagination";
import {getPageSummary}         from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {PageList}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PageSize}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";

const PAGE_SIZES = [5, 10, 20]

export const MlColumn = ({mailingLists, entityId=null}) => cs(
    ["pageSize", (_, next) => UseState({next, getInitValue: () => PAGE_SIZES[0]})],
    ["pagination", ({pageSize}, next) => Pagination({
        _key: JSON.stringify(pageSize),
        pageSize: pageSize.value,
        rows: mailingLists?.value,
        next,
    })],
    ["sortMailingLists", ({}, next) => next(mailingListsMoreRecentFirst(mailingLists))],
    ["displayedRows", ({pagination}, next) => next(pagination?.active ? pagination.getDisplayedRows() : mailingLists.value)],
    ({pagination, pageSize, displayedRows}) => (
        <div className="mailing-list-column-TiO2">
            { 
                displayedRows?.map(mailingList =>
                    <React.Fragment key={mailingList.id}>
                        <MlCard entityId={entityId} mailingList={mailingList} mailingLists={mailingLists} />
                    </React.Fragment> 
                ) 
            }
            {
                displayedRows?.length
                ?
                <div className="controls">
                    <div className="pagination-row">
                        {
                            PageSize({
                                sizes: PAGE_SIZES,
                                state: pageSize,
                                pageSizeMessage: "",
                            })
                        }
                        {
                            
                            pagination.active
                            ? 
                            <div className="pagination">
                                {PageList(pagination)}
                            </div>
                            :
                            null                       
                        }
                    </div>
                    {          
                        getPageSummary({
                            pageIndex: pagination.state.value,
                            pageSize: pageSize.value,
                            count: mailingLists.value.length
                        })
                    }
                </div>
                : 
                null
            }
        </div>
    )
);

const mailingListsMoreRecentFirst = (mailingLists) => {
    if(!mailingLists.value) {
        return
    }

    mailingLists.value.sort((listFirst, listSecond) => {
        const dateFirst = new Date(listFirst.dateCreated)
        const dateSecond = new Date(listSecond.dateCreated)

        if(dateFirst < dateSecond) {
            return 1
        }

        if(dateFirst > dateSecond) {
            return -1
        }
        
        return 0
    })
}
